import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 54444 48871"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:603.216}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974340249392">
        <path
          d="M20272 18724c4925-2599 9852-2595 14777 0L33202 1895c-3760-2026-7524-2224-11288 0l-1642 16829zM40518 28813c-285 5561-2807 9793-7556 12700l15408 7017c3663-2196 5757-5330 5771-9702L40518 28813zM21439 40790c-4820-2789-7438-6962-7860-12513L311 38793c285 4261 2120 7553 6005 9558l15123-7561zM27554 21010c4762 0 8619 3857 8619 8620 0 4761-3857 8619-8619 8619s-8619-3858-8619-8619c0-4763 3857-8620 8619-8620z"
          className="fill stroke1"
          style={{
            strokeWidth: 603.216,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
